import {
  SET_BULK_FORM_SELECTIONS,
  SET_BULK_FORM_HAS_ERROR,
  SET_BULK_FORM_HAS_SUBMITTED,
  SUBMIT_BULK_FORM_SELECTIONS_PENDING,
  SUBMIT_BULK_FORM_SELECTIONS_FULFILLED,
  SUBMIT_BULK_FORM_SELECTIONS_FAILED,
  GET_BULK_PICKUP_DATES_PENDING,
  GET_BULK_PICKUP_DATES_FULFILLED,
  GET_BULK_PICKUP_DATES_FAILED,
  GET_BULK_PICKUP_LOCATIONS_PENDING,
  GET_BULK_PICKUP_LOCATIONS_FULFILLED,
  GET_BULK_PICKUP_LOCATIONS_FAILED,
} from "constants-lib/actionTypes"

export const initialState = {
  bulkFormSelections: {},
  bulkFormHasError: false,
  submitBulkFormStatus: ``,
  bulkPickupLocationData: {},
  getBulkPickupLocationStatus: ``,
  bulkPickupDatesData: [],
  getBulkPickupDatesStatus: ``,
  bulkFormHasSubmitted: false,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_BULK_FORM_SELECTIONS:
      return {
        ...state,
        bulkFormSelections: action.payload,
      }

    case SET_BULK_FORM_HAS_ERROR:
      return {
        ...state,
        bulkFormHasError: action.payload,
      }

    case SET_BULK_FORM_HAS_SUBMITTED:
      return {
        ...state,
        bulkFormHasSubmitted: action.payload,
      }

    case SUBMIT_BULK_FORM_SELECTIONS_PENDING:
      return {
        ...state,
        submitBulkFormStatus: `pending`,
      }

    case SUBMIT_BULK_FORM_SELECTIONS_FULFILLED:
      return {
        ...state,
        submitBulkFormStatus: `fulfilled`,
      }

    case SUBMIT_BULK_FORM_SELECTIONS_FAILED:
      return {
        ...state,
        submitBulkFormStatus: `failed`,
      }

    case GET_BULK_PICKUP_DATES_PENDING:
      return {
        ...state,
        getBulkPickupDatesStatus: `pending`,
      }

    case GET_BULK_PICKUP_DATES_FULFILLED:
      return {
        ...state,
        bulkPickupDatesData: action.payload,
        getBulkPickupDatesStatus: `fulfilled`,
      }

    case GET_BULK_PICKUP_DATES_FAILED:
      return {
        ...state,
        getBulkPickupDatesStatus: `failed`,
      }

    case GET_BULK_PICKUP_LOCATIONS_PENDING:
      return {
        ...state,
        getBulkPickupLocationStatus: `pending`,
      }

    case GET_BULK_PICKUP_LOCATIONS_FULFILLED:
      return {
        ...state,
        bulkPickupLocationData: action.payload,
        getBulkPickupLocationStatus: `fulfilled`,
      }

    case GET_BULK_PICKUP_LOCATIONS_FAILED:
      return {
        ...state,
        getBulkPickupLocationStatus: `failed`,
      }

    default:
      return state
  }
}
